import { 
  GET_REQUEST_TRANSLATION, 
  GET_REQUEST_TRANSLATION_ERROR, 
  GET_REQUEST_TRANSLATION_SUCCESS, 
  GET_FACULTIES,
  GET_FACULTIES_ERROR,
  GET_FACULTIES_SUCCESS,
  GET_LANGUAGES,
  GET_LANGUAGES_ERROR,
  GET_LANGUAGES_SUCCESS,
  GET_PAYMENT_METHODS,
  GET_PAYMENT_METHODS_ERROR,
  GET_PAYMENT_METHODS_SUCCESS,
  GET_PROVIDERS,
  GET_PROVIDERS_SUCCESS,
  GET_PROVIDERS_ERROR,
  EDIT_REQUEST,
  EDIT_REQUEST_SUCCESS,
  EDIT_REQUEST_ERROR,
  GET_CUSTOMERS,
  GET_CUSTOMERS_SUCCESS,
  GET_CUSTOMERS_ERROR,
  GET_ROLES,
  GET_ROLES_SUCCESS,
  GET_ROLES_ERROR,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR,
  ADD_CUSTOMER,
  ADD_CUSTOMER_SUCCESS,
  ADD_CUSTOMER_ERROR,
  EDIT_CUSTOMER,
  EDIT_CUSTOMER_SUCCESS,
  EDIT_CUSTOMER_ERROR,
  ADD_PROVIDER,
  ADD_PROVIDER_SUCCESS,
  ADD_PROVIDER_ERROR,
  EDIT_PROVIDER,
  EDIT_PROVIDER_SUCCESS,
  EDIT_PROVIDER_ERROR
} from 'redux/constants/Request';

/**
 * GET REQUEST TRANSLATION
 * @param {*} page 
 * @param {*} size 
 * @returns 
 */
export const getRequestTranslation = (query) => {
  return {
    type: GET_REQUEST_TRANSLATION,
    payload: {
      query
    }
  }
};

/**
 * GET REQUEST TRANSLATION SUCCESS
 * @param {*} data 
 * @returns 
 */
export const getRequestTranslationSuccess = (data) => {
  return {
    type: GET_REQUEST_TRANSLATION_SUCCESS,
    data
  }
};

/**
 * GET REQUEST TRANSLATION ERROR
 * @param {*} message 
 * @returns 
 */
export const getRequestTranslationError = (message) => {
  return {
    type: GET_REQUEST_TRANSLATION_ERROR,
    message
  }
};

/**
 * GET FACULTIES
 * @returns 
 */
export const getFaculties = () => {
  return {
    type: GET_FACULTIES,
  }
};

/**
 * GET FACULTIES SUCCESS
 * @param {*} specialities 
 * @param {*} faculties 
 * @param {*} universities 
 * @returns 
 */
export const getFacultiesSuccess = (specialities, faculties, universities) => {
  return {
    type: GET_FACULTIES_SUCCESS,
    specialities,
    faculties,
    universities
  }
};

/**
 * GET FACULTIES ERROR
 * @param {*} message 
 * @returns 
 */
export const getFacultiesError = (message) => {
  return {
    type: GET_FACULTIES_ERROR,
    message
  }
};


/**
 * GET LANGUAGES
 * @returns 
 */
 export const getLanguages = () => {
  return {
    type: GET_LANGUAGES,
  }
};

/**
 * GET LANGUAGES SUCCESS
 * @param {*} languages 
 * @returns 
 */
export const getLanguagesSuccess = (languages) => {
  return {
    type: GET_LANGUAGES_SUCCESS,
    languages
  }
};

/**
 * GET LANGUAGES ERROR
 * @param {*} message 
 * @returns 
 */
export const getLanguagesError = (message) => {
  return {
    type: GET_LANGUAGES_ERROR,
    message
  }
};

/**
 * GET PAYMENT METHODS
 * @returns 
 */
 export const getPaymentMethods = () => {
  return {
    type: GET_PAYMENT_METHODS,
  }
};

/**
 * GET PAYMENT METHODS SUCCESS
 * @param {*} paymentMethods 
 * @returns 
 */
export const getPaymentMethodsSuccess = (paymentMethods) => {
  return {
    type: GET_PAYMENT_METHODS_SUCCESS,
    paymentMethods
  }
};

/**
 * GET PAYMENT METHODS ERROR
 * @param {*} message 
 * @returns 
 */
export const getPaymentMethodsError = (message) => {
  return {
    type: GET_PAYMENT_METHODS_ERROR,
    message
  }
};

/**
 * GET PROVIDERS
 * @returns 
 */
 export const getProviders = (query) => {
  return {
    type: GET_PROVIDERS,
    payload: {
      query
    }
  }
};

/**
 * GET PROVIDERS SUCCESS
 * @param {*} providers 
 * @returns 
 */
export const getProvidersSuccess = (providers) => {
  return {
    type: GET_PROVIDERS_SUCCESS,
    providers
  }
};

/**
 * GET PROVIDERS ERROR
 * @param {*} message 
 * @returns 
 */
export const getProvidersError = (message) => {
  return {
    type: GET_PROVIDERS_ERROR,
    message
  }
};

/**
 * GET CUSTOMERS
 * @returns 
 */
 export const getCustomers = (query) => {
  return {
    type: GET_CUSTOMERS,
    payload: {
      query
    }
  }
};

/**
 * GET CUSTOMERS SUCCESS
 * @param {*} customers 
 * @returns 
 */
export const getCustomersSuccess = (customers) => {
  return {
    type: GET_CUSTOMERS_SUCCESS,
    customers
  }
};

/**
 * GET CUSTOMERS ERROR
 * @param {*} message 
 * @returns 
 */
export const getCustomersError = (message) => {
  return {
    type: GET_CUSTOMERS_ERROR,
    message
  }
};

/**
 * GET ROLES
 * @returns 
 */
 export const getRoles = (query) => {
  return {
    type: GET_ROLES,
    payload: {
      query
    }
  }
};

/**
 * GET ROLES SUCCESS
 * @param {*} roles 
 * @returns 
 */
export const getRolesSuccess = (roles) => {
  return {
    type: GET_ROLES_SUCCESS,
    roles
  }
};

/**
 * GET ROLES ERROR
 * @param {*} message 
 * @returns 
 */
export const getRolesError = (message) => {
  return {
    type: GET_ROLES_ERROR,
    message
  }
};

/**
 * EDIT REQUEST
 * @returns 
 */
 export const editRequest = (data, cb = () => {}) => {
  return {
    type: EDIT_REQUEST,
    payload: {
      data,
      cb
    }
  }
};

/**
 * EDIT REQUEST SUCCESS
 * @returns 
 */
export const editRequestSuccess = () => {
  return {
    type: EDIT_REQUEST_SUCCESS,
  }
};

/**
 * EDIT REQUEST ERROR
 * @param {*} message 
 * @returns 
 */
export const editRequestError = (message) => {
  return {
    type: EDIT_REQUEST_ERROR,
    message
  }
};

/**
 * DELETE USER
 * @returns 
 */
 export const deleteUser = (id, type, cb = () => {}) => {
  return {
    type: DELETE_USER,
    payload: {
      id,
      type,
      cb
    }
  }
};

/**
 * DELETE USER SUCCESS
 * @returns 
 */
export const deleteUserSuccess = (data, cb = () => {}) => {
  return {
    type: DELETE_USER_SUCCESS,
  }
};

/**
 * DELETE USER ERROR
 * @returns 
 */
export const deleteUserError = (data, cb = () => {}) => {
  return {
    type: DELETE_USER_ERROR,
  }
};

/**
 * ADD CUSTOMER
 * @returns 
 */
 export const addCustomer = (data, cb = () => {}) => {
  return {
    type: ADD_CUSTOMER,
    payload: {
      data,
      cb
    }
  }
};

/**
 * ADD CUSTOMER SUCCESS
 * @returns 
 */
export const addCustomerSuccess = (data, cb = () => {}) => {
  return {
    type: ADD_CUSTOMER_SUCCESS,
  }
};

/**
 * ADD CUSTOMER ERROR
 * @returns 
 */
export const addCustomerError = (data, cb = () => {}) => {
  return {
    type: ADD_CUSTOMER_ERROR,
  }
};

/**
 * EDIT CUSTOMER
 * @returns 
 */
export const editCustomer = (data, cb = () => {}) => {
  return {
    type: EDIT_CUSTOMER,
    payload: {
      data,
      cb
    }
  }
};

/**
 * EDIT CUSTOMER SUCCESS
 * @returns 
 */
export const editCustomerSuccess = (data, cb = () => {}) => {
  return {
    type: EDIT_CUSTOMER_SUCCESS,
  }
};

/**
 * EDIT CUSTOMER ERROR
 * @returns 
 */
export const editCustomerError = (data, cb = () => {}) => {
  return {
    type: EDIT_CUSTOMER_ERROR,
  }
};

/**
 * ADD PROVIDER
 * @returns 
 */
 export const addProvider = (data, cb = () => {}) => {
  return {
    type: ADD_PROVIDER,
    payload: {
      data,
      cb
    }
  }
};

/**
 * ADD PROVIDER SUCCESS
 * @returns 
 */
export const addProviderSuccess = (data, cb = () => {}) => {
  return {
    type: ADD_PROVIDER_SUCCESS,
  }
};

/**
 * ADD PROVIDER ERROR
 * @returns 
 */
export const addProviderError = (data, cb = () => {}) => {
  return {
    type: ADD_PROVIDER_ERROR,
  }
};

/**
 * EDIT PROVIDER
 * @returns 
 */
export const editProvider = (data, cb = () => {}) => {
  return {
    type: EDIT_PROVIDER,
    payload: {
      data,
      cb
    }
  }
};

/**
 * EDIT PROVIDER SUCCESS
 * @returns 
 */
export const editProviderSuccess = (data, cb = () => {}) => {
  return {
    type: EDIT_PROVIDER_SUCCESS,
  }
};

/**
 * EDIT PROVIDER ERROR
 * @returns 
 */
export const editProviderError = (data, cb = () => {}) => {
  return {
    type: EDIT_PROVIDER_ERROR,
  }
};